(() => {
  const overrides = window.__wearseImageOverrides;
  const mappings = [
    {
      oldName: 'ChatGPT_Image_Sep_14_2026_09_54_12_AM.png',
      newSrc: overrides?.classShoes,
      alt: 'Chaussures Classe',
    },
    {
      oldName: 'wearse-pantalon-bleu-lp-fr.png',
      newSrc: overrides?.pantsBlue,
      alt: 'Pantalon WEARSE bleu marine porté',
      correctAlt: true,
    },
    {
      oldName: 'wearse-pantalon-noir.png',
      newSrc: overrides?.pants,
      alt: 'Pantalon WEARSE noir porté',
      correctAlt: true,
    },
    {
      oldName: 'wearse-pantalon-marron.png',
      newSrc: overrides?.pantsBrown,
      alt: 'Pantalon WEARSE marron porté',
      correctAlt: true,
    },
    {
      oldName: 'wearse-pantalon-beige.png',
      newSrc: overrides?.pantsBeige,
      alt: 'Pantalon WEARSE beige porté',
      correctAlt: true,
    },
  ].filter((mapping) => mapping.newSrc);

  if (!mappings.length) return;

  const attributes = ['src', 'srcset', 'data-src', 'data-srcset'];
  const productMediaContextSelector = [
    'a[href*="/products/"]',
    '.card-wrapper',
    '.product-card-wrapper',
    '.wearse-home-product',
    '.wearse-shoes-card',
    '.wtl-card',
    '.cart-item',
    '.cart-notification-product',
    '.predictive-search__item',
    '.variant-item',
    '.product__media-wrapper',
  ].join(', ');
  const replacementFor = (element) => mappings.find((mapping) =>
    attributes.some((name) =>
      String(element.getAttribute?.(name) || '').includes(mapping.oldName),
    ),
  );

  // Le CDN Shopify redimensionne les fichiers et sert automatiquement
  // WebP/AVIF : on construit donc un srcset au lieu de charger l'original.
  const widths = [320, 480, 640, 900, 1200];
  const sizedUrl = (base, width) =>
    base + (base.includes('?') ? '&' : '?') + 'width=' + width;
  const srcsetFor = (base) => widths.map((width) => sizedUrl(base, width) + ' ' + width + 'w').join(', ');

  function replaceImage(element) {
    if (!(element instanceof Element)) return;
    if (element.closest(productMediaContextSelector)) return;
    const replacement = replacementFor(element);
    if (!replacement) return;

    if (element.tagName === 'SOURCE') {
      element.removeAttribute('sizes');
      element.removeAttribute('data-srcset');
      element.setAttribute('srcset', srcsetFor(replacement.newSrc));
      element.setAttribute('sizes', '(min-width: 750px) 50vw, 100vw');
      return;
    }

    if (element.tagName === 'IMG') {
      // On ne saute que si l'image a déjà été remplacée par nos soins
      // (fichier du thème + largeur demandée) : l'image produit d'origine,
      // elle, porte aussi un "width=" mais doit bien être remplacée.
      const current = String(element.getAttribute('src') || '');
      const alreadyOptimized = current.includes('/cdn/shop/t/') && current.includes('width=');
      if (alreadyOptimized) return;
      element.removeAttribute('data-src');
      element.removeAttribute('data-srcset');
      element.src = sizedUrl(replacement.newSrc, 900);
      element.setAttribute('srcset', srcsetFor(replacement.newSrc));
      element.setAttribute('sizes', element.getAttribute('sizes') || '(min-width: 750px) 50vw, 100vw');
      if (replacement.correctAlt || !element.alt) element.alt = replacement.alt;
    }
  }

  function scan(root) {
    if (root instanceof Element && root.matches('img, source')) replaceImage(root);
    root.querySelectorAll?.('img, source').forEach(replaceImage);
  }

  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') replaceImage(record.target);
      record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: attributes,
  });
})();
